import React from "react";
import * as Types from "./types";
import { getComputedValue } from "./util";

var toView = function toView(value) {
  if (value === false) {
    return /*#__PURE__*/React.createElement("div", {
      className: "Spreadsheet__data-viewer--boolean"
    }, "FALSE");
  }

  if (value === true) {
    return /*#__PURE__*/React.createElement("div", {
      className: "Spreadsheet__data-viewer--boolean"
    }, "TRUE");
  }

  return value;
};

var DataViewer = function DataViewer(_ref) {
  var getValue = _ref.getValue,
      cell = _ref.cell,
      column = _ref.column,
      row = _ref.row,
      formulaParser = _ref.formulaParser;
  return toView(getComputedValue({
    getValue: getValue,
    cell: cell,
    column: column,
    row: row,
    formulaParser: formulaParser
  }));
};

export default DataViewer;